import Config from "@skin_config";
import { BetStateEnum } from "@app/dev/constants/enums/betState";
import { store } from "@app/dev/index/terminalApp";
import { getAuthData } from "@common/helpers/auth";
import { GetCurrencyConfig } from "@common/helpers/selectors";
import { TicketTypes } from "@tickets/constants";
import { formatMoneyAmount } from "@common/helpers/amount";

export const getTicketWinAmount = (ticket) => {
  const { dataFromSwarm } = ticket;

  if (!dataFromSwarm) return 0;

  const authData = getAuthData();
  const currencyConfig = GetCurrencyConfig(store.getState(), Config.main.currencySymbolRounding);

  const taxAmount =
    ticket.dataFromSwarm.state_id !== BetStateEnum.Returned
      ? dataFromSwarm.tax_amount ?? dataFromSwarm.possible_tax_amount ?? 0
      : 0;

  const winAmount =
    ticket.ticketType === TicketTypes.DEPOSIT
      ? dataFromSwarm.amount
      : dataFromSwarm.win_amount ?? dataFromSwarm.WinAmount;

  const calculatedWinAmount = winAmount - taxAmount

  if (calculatedWinAmount <= 0) return 0;

  const amount = +formatMoneyAmount(calculatedWinAmount, Config, { name: authData.currency, ...currencyConfig }, true)

  return isNaN(amount) ? 0 : amount ; // just for rounding, need to call here only round function
};
